<div class="oauth2-client-dialog-content">
  <div class="dialog-header">
    <div class="client-logo">
      <img class="client-logo-img" [src]="logoUri" alt="client logo">
    </div>
    <div class="client-name">{{client.client_name}}</div>
  </div>
  <div class="dialog-content">
    @if (client.client_uri) {
      <div class="client-uri">Details: <a [href]="client.client_uri">{{client.client_uri}}</a></div>
    }
    @if (client.tos_uri) {
      <div class="client-tos">Terms of Service: <a [href]="client.tos_uri">{{client.tos_uri}}</a></div>
    }
    @if (client.policy_uri) {
      <div class="client-policy">Policy: <a [href]="client.policy_uri">{{client.policy_uri}}</a></div>
    }
    @if (client.contacts && client.contacts.length > 0) {
      <div class="client-desc">
        <div class="section-head">Contacts</div>
        @for (contact of client.contacts; track contact) {
          <span class="ui label">{{client.contacts}}</span>
        }
      </div>
    }
    <div class="permission-list">
      <div class="section-head">Permissions</div>
      <ul class="ui list">
        @for (scope of scopeList; track scope) {
          <li class="item">{{scope}}</li>
        }
      </ul>
    </div>
  </div>
</div>
